import React, { useContext } from "react"
import { Link } from "react-router-dom"
import moment from "moment"

import Card from "@material-ui/core/Card"
import { Tooltip } from "@material-ui/core"

import AuthContext from "../../../../context/auth-context"
import { translateFraudStatus, fraudStatusSiglum, fraudStatusColor } from "../../utils/utils"

function FaceDatabaseValidationCard(props) {
    const user_data = useContext(AuthContext).user_data

    const showLink = !(
        props.event.analysis_status === "pending" ||
        props.event.analysis_status === "in_queue" ||
        props.event.analysis_status === "waiting_for_data" ||
        props.event.analysis_status === "failed"
    )

    return (
        <Card className={["listCard", "collapse"].join(" ")}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                {showLink
                    ? <Link
                        className={["listCardItem", "link", "subtitleSize", "bold"].join(" ")}
                        style={{ flex: "2 1 120px", textAlign: "center" }}
                        to={"/face-database-validation/" + props.event.event_key}
                    >
                        {props.event.event_key}
                    </Link>
                    : <div
                        className={["listCardItem", "subtitleSize", "bold"].join(" ")}
                        style={{ flex: "2 1 120px", textAlign: "center" }}
                    >
                        {props.event.event_key}
                    </div>
                }
                {user_data.business_group_key && props.event.company_name &&
                    <div
                        className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                        style={{ flex: "2 1 200px", textAlign: "center" }}
                    >
                        {props.event.company_name}
                    </div>
                }
                <div
                    className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                    style={{ flex: "1 1 145px", textAlign: "center" }}
                >
                    {props.event.event_data?.document_number}
                </div>
                <div
                    className={["listCardItem", "normalText", "normalMediumSize", "bold"].join(" ")}
                    style={{ flex: "1 1 45px", textAlign: "center", cursor: "default" }}
                >
                    <Tooltip title={<p className="tooltipText">{translateFraudStatus(props.event.analysis_status)}</p>}>
                        <div
                            className={["circle", "small"].join(" ")}
                            style={{ backgroundColor: fraudStatusColor(props.event.analysis_status) }}
                        >
                            {fraudStatusSiglum(props.event.analysis_status)}
                        </div>
                    </Tooltip>
                </div>
                <div
                    className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                    style={{ flex: "1 1 110px", textAlign: "center" }}
                >
                    {moment(props.event.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </div>
            </div>
        </Card>
    )
}

export default FaceDatabaseValidationCard
